import { Component } from '@angular/core';

@Component({
  selector: 'go-footer',
  styleUrls: ['./go-footer.component.scss'],
  templateUrl: './go-footer.component.html'
})
export class GoFooterComponent {

}
